import { render, staticRenderFns } from "./DraftProductsView.vue?vue&type=template&id=d0bbfee6"
import script from "./DraftProductsView.vue?vue&type=script&lang=js"
export * from "./DraftProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports